var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: _vm.fill,
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [_c("path", { attrs: { d: "m9 18 6-6-6-6" } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }